import ServerBaseError from './ServerBaseError';

export default class ServerGatewayTimeoutError extends ServerBaseError {
  constructor(message = 'The server did not respond in time', showErrorPage = false) {
    super(message, showErrorPage);
  }
}
